var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00029 1.50031C3.23904 1.50031 1.00061 3.73874 1.00061 6.49999C1.00061 9.26124 3.23904 11.4997 6.00029 11.4997C8.76154 11.4997 11 9.26124 11 6.49999C11 3.73874 8.76154 1.50031 6.00029 1.50031ZM0.000610352 6.49999C0.000610352 3.18645 2.68676 0.500305 6.00029 0.500305C9.31382 0.500305 12 3.18645 12 6.49999C12 9.81352 9.31382 12.4997 6.00029 12.4997C2.68676 12.4997 0.000610352 9.81352 0.000610352 6.49999ZM8.00375 4.49653C8.19901 4.69179 8.19901 5.00837 8.00375 5.20364L6.7074 6.49999L8.00375 7.79634C8.19901 7.9916 8.19901 8.30818 8.00375 8.50344C7.80849 8.69871 7.49191 8.69871 7.29664 8.50344L6.00029 7.20709L4.70394 8.50344C4.50868 8.69871 4.1921 8.69871 3.99683 8.50344C3.80157 8.30818 3.80157 7.9916 3.99683 7.79634L5.29319 6.49999L3.99683 5.20364C3.80157 5.00837 3.80157 4.69179 3.99683 4.49653C4.1921 4.30127 4.50868 4.30127 4.70394 4.49653L6.00029 5.79288L7.29664 4.49653C7.49191 4.30127 7.80849 4.30127 8.00375 4.49653Z",
    fill: "#FC4D0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAll);
export default __webpack_public_path__ + "static/media/clear-all.fc60581b7346ef769a8fb01e93221a17.svg";
export { ForwardRef as ReactComponent };